
import React from 'react'
import { Tab, Container } from 'semantic-ui-react';
import CrearServico from './CrearServico';
import PlanesEbiex from './PlanesEbiex';
import ProductWeb from './ProductWeb'
import RatesEbiex from './RatesEbiex';
import TypesPackage from './TypesPackage';
import {db} from '../../../firebase'


      //Acount shipments  
            var inicio = 'Bienvenido'
            var itemproductWeb = 'No se muestran datos'
            var crearServico='Sin contenido'
            var typespackage = 'No se muestran datos'
            var ratesEbiex = 'No se muestran datos'
            var planesEbiex = 'No se muestran datos'
            const panes = [
            {
              menuItem: 'Inicio',
              render: () => <Tab.Pane  className="item" attached={false}>{inicio}</Tab.Pane>,
            },
            {
              menuItem: 'Crear Servicios',
              render: () => <Tab.Pane  className="item" attached={false}>{crearServico}</Tab.Pane>,
            },
             {
               menuItem: 'Tipos de paquetes',
               render: () => <Tab.Pane  className="item" attached={false}>{typespackage}</Tab.Pane>,
             },
             {
               menuItem: 'Tarifarios',
               render: () => <Tab.Pane   className="item"  attached={false}>{ratesEbiex}</Tab.Pane>,
             },
             {
              menuItem: 'Planes BICCI EXPRESS',
              render: () => <Tab.Pane   className="item"  attached={false}>{planesEbiex}</Tab.Pane>,
            },
            {
              menuItem: 'Productos web',
              render: () => <Tab.Pane  className="item" attached={false}>{itemproductWeb}</Tab.Pane>,
            },
          ]
const  Serviciosmanagement =(props)=>{

const [dataRates,setDataRates] = React.useState()
const [paqRates,setPaqRates] = React.useState()
const [tarifariosData,setTarifariosData] = React.useState()
const [paymentMethods,setPaymentMethods] = React.useState()
const [paymentOptions, setPaymentOptions] = React.useState()
const [plansdata, setPlansData]= React.useState()
const [productWeb,setProductWeb]=React.useState()
const [productData,setProductData] = React.useState()
  React.useEffect (()=>{
    async  function  getServices () {
      try {
        const services = await db.collection(`${process.env.REACT_APP_COL_AVIABLE_SERV}`)
        .get();
        
        const data = services.docs.map(doc => ({id: doc.id, ...doc.data()}))
 //         // console.log(data)
          setDataRates(data)
      } catch (error) {
        
      }
    }
    getServices()

    async  function  getPaquetes () {
      try {
        const tipospaquetes = await db.collection(`${process.env.REACT_APP_COL_TYPEPACKS}` )
        .get();
        
        const data2 = tipospaquetes.docs.map(doc => ({id: doc.id, ...doc.data()}))
          // console.log(data2)
        setPaqRates(data2)
      } catch (error) {
        
      }
    }
    getPaquetes()
    async  function  findTaridarios () {
      try {
        const tarifarios = await db.collection(`${process.env.REACT_APP_COL_RATES}`)
        .get();
        const data3 = tarifarios.docs.map(doc => ({id: doc.id, ...doc.data()}))
          // console.log(data3)
        setTarifariosData(data3)
      } catch (error) {
        
      }
    }
    findTaridarios()
    async  function  findpaymentmethods () {
      try {
        const paymethods = await db.collection(`${process.env.REACT_APP_COL_PAYMETHODS}`)
        .get();
        const data4 = paymethods.docs.map(doc => ({id: doc.id, ...doc.data()}))
          //        // console.log(data2)
          setPaymentMethods(data4)
      } catch (error) {
      }
    }
    findpaymentmethods()

    async  function  paymentOptions () {
      try {
        const payOptions = await db.collection(`${process.env.REACT_APP_COL_PAYOPTIONS}`)
        .get();
        const data5 = payOptions.docs.map(doc => ({id: doc.id, ...doc.data()}))
          //        // console.log(data2)
          setPaymentOptions(data5)
      } catch (error) {
      }
    }
    paymentOptions()
    async  function  findplansdata () {
      try {
        const paymethods = await db.collection(`${process.env.REACT_APP_COL_AVIABLEPLANS}`)
        .get();
        const data4 = paymethods.docs.map(doc => ({id: doc.id, ...doc.data()}))
          //        // console.log(data2)
          setPlansData(data4)
          const plansActive = data4.filter(item => item.isActive === true) // Activo
          const plansPost = plansActive.filter(item => item.isPublic === true) // Is Public
          plansPost.sort((a, b) => (parseInt(a.position) > parseInt(b.position))?1:-1) ;
          setProductWeb(plansPost)
      } catch (error) {
      }
    }
    findplansdata()
    async  function  findproductdata () {
      try {
        const paymethods = await db.collection(`${process.env.REACT_APP_COL_PRODUCTS}`)
        .get();
        const data5 = paymethods.docs.map(doc => ({id: doc.id, ...doc.data()}))
          setProductData(data5)
          // const plansActive = data4.filter(item => item.isDelect === false) // Activo
          // const plansPost = plansActive.filter(item => item.isPublic === true) // Is Public
          // plansPost.sort((a, b) => (parseInt(a.position) > parseInt(b.position))?1:-1) ;
          // setProductWeb(plansPost)
      } catch (error) {
      }
    }
    findproductdata()

  },[]);

    inicio= (<div> <Container className="dashcontent">Bienvenido, Instrucciones</Container></div>)
    itemproductWeb = (<ProductWeb props={props} userUid={props.userUid} dataRates={dataRates} paqRates={paqRates} tarifariosData={tarifariosData} paymentMethods={paymentMethods} paymentOptions={paymentOptions} productWeb={productWeb} productData={productData}></ProductWeb>)
    crearServico = (<CrearServico props={props} paqRates={paqRates} dataRates={dataRates}></CrearServico>)
    typespackage = (<TypesPackage props={props} paqRates={paqRates} dataRates={dataRates}></TypesPackage>)
    ratesEbiex = (<RatesEbiex props={props} userUid={props.userUid} dataRates={dataRates} paqRates={paqRates} tarifariosData={tarifariosData} paymentMethods={paymentMethods} paymentOptions={paymentOptions}></RatesEbiex>)
    planesEbiex = (<PlanesEbiex props={props}  userUid={props.userUid} dataRates={dataRates} paqRates={paqRates} tarifariosData={tarifariosData} paymentMethods={paymentMethods} paymentOptions={paymentOptions} plansdata={plansdata} ></PlanesEbiex>)



return (
  <Tab className="tabular menu" menu={{ secondary: true }} panes={panes}></Tab>
  )

}



export default Serviciosmanagement